<div class="bg-[url('/assets/images/header.jpg')] bg-cover bg-center h-96">
  <div class="px-8 lg:px-8 m-auto max-w-[1600px] flex flex-col bg-black/[0.65] py-6 pt-12 pb-12 h-full">
    <div class="flex flex-col justify-center text-white h-full">
      <h1 class="text-4xl mb-8 font-bold">{{ { key: 'shootingRange' } | i18n }}</h1>
      <p>{{ { key: 'shootingRangeOpen' } | i18n }}</p>
    </div>
  </div>
</div>

<!-- <div class="w-full py-12 bg-primary-600 flex flex-row items-center justify-center">
  <h2 class="text-3xl font-bold text-white text-center m-0">{{ { key: 'offers' } | i18n }}</h2>
</div> -->

<div class="px-8 lg:px-8 m-auto max-w-[1600px] pb-6 py-6 mt-12 mb-12">
  @if (website.observeAuthenticated() | async) {
    @if (meta.isLoading()) {
      <app-loading [noWhitespace]="true"></app-loading>
    } @else if (meta.error()) {
      {{ { key: 'error' } | i18n }}
    } @else {
      @if (meta.value()?.isAllowedToBook) {
        @if (bookingOptions.isLoading()) {
          <app-loading [noWhitespace]="true"></app-loading>
        } @else if (bookingOptions.error()) {
          {{ { key: 'error' } | i18n }}
        } @else {
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            @for (option of bookingOptions.value(); track option.key) {
              <div class="bg-primary text-contrast p-4">
                <h3 class="text-2xl font-bold h-20">{{ option.title | i18n }}</h3>
                <p class="h-32 md:h-24">
                  {{ option.designation | i18n }}
                </p>

                <!-- @if (option.hasPermission) { -->
                <a [routerLink]="['/places/book']" [queryParams]="{ option: option.key }">
                  <button class="w-full text-black bg-white border-2 hover:bg-primary-600 hover:text-white hover:border-2 border-white p-4">
                    {{ { key: 'book' } | i18n }}
                  </button>
                </a>
                <!-- } @else {
                  <button class="w-full cursor-not-allowed bg-gray-100 border-2 border-gray-200 p-4 mb-8">
                    {{ { key: 'noPermission' } | i18n }}
                  </button>
                } -->
              </div>
            }
          </div>
        }
      } @else if (meta.value()?.hasPendingApprovalRequest) {
        <div class="flex flex-col items-center justify-center">
          <h2 class="text-2xl font-bold">{{ { key: 'approvalPending' } | i18n }}</h2>
          <p class="mt-4">{{ { key: 'approvalPendingMessage' } | i18n }}</p>
        </div>
      } @else {
        <div class="flex flex-col items-center justify-center">
          <h2 class="text-2xl font-bold">{{ { key: 'missingApproval' } | i18n }}</h2>
          <p class="mt-4">{{ { key: 'missingApprovalMessage' } | i18n }}</p>
          <button (click)="overlay.openInfoOverlay()" class="mt-8 bg-primary-600 text-white p-4">
            {{ { key: 'fillData' } | i18n }}
          </button>
        </div>
      }
    }
  } @else {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-24 md:gap-8 text-center items-start">
      <div class="flex flex-col items-center justify-center">
        <h2 class="text-center text-2xl font-bold">{{ { key: 'bookingYouHaveAnAccount' } | i18n }}</h2>
        <button (click)="website.login()" class="mt-8 bg-primary-600 text-white p-4">{{ { key: 'login' } | i18n }}</button>
      </div>
      <div class="flex flex-col items-center justify-center">
        <h2 class="text-center text-2xl font-bold">{{ { key: 'bookingNeedAnAccount' } | i18n }}</h2>
        <p class="mb-8">{{ { key: 'bookingNeedAnAccountInfo' } | i18n }}</p>
        <div class="flex flex-col text-center gap-2">
          @for (file of legalFiles.value(); track file._id) {
            <a [href]="file.url" target="_blank" class="text-primary-600 hover:underline">
              {{ file.designation | i18n }}
            </a>
          }
        </div>
        <button (click)="website.signup()" class="mt-8 bg-primary-600 text-white p-4">{{ { key: 'signUp' } | i18n }}</button>
      </div>
    </div>
  }
</div>
